import Drawer from "@mui/material/Drawer";
import React, { ReactNode } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import * as actions from "../../../../../store/actions";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import SidebarImage from "../../../../../assets/img/pipes.webp";
import { useAppDispatch, useAppSelector } from "../../../../../store";

export default function JzSidebar({ children }: { children: ReactNode }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const open = useAppSelector((state) => state.app.mobileOpen);
  const mini = useAppSelector((state) => state.app.sidebarMiniActive);
  const width = mini ? 120 : 260;
  const dispatch = useAppDispatch();

  return (
    <Drawer
      onClose={() => {
        dispatch({ type: actions.TOGGLE_MOBILE });
      }}
      open={open}
      sx={{
        "& .MuiDrawer-paper": {
          transition: "all 200ms ease-in",
          width,
          "&::before": {
            transition: "all 200ms ease-in",
            width,
            content: `""`,
            position: "fixed",
            backgroundClip: "260px",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            backgroundImage: `url(${SidebarImage})`,
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            zIndex: -1,
            filter: "opacity(35%)",
          },
        },
      }}
      variant={isMobile ? "temporary" : "permanent"}
    >
      {children}
    </Drawer>
  );
}
